'use strict';

function FormatPaymentItemTypeFilter() {
    return function formatItemType(value) {
        const descs = {
            cash: 'EF',
            bankTx: 'TR',
            check: 'CH'
        };
        return descs[value] || '';
    };
}

export default FormatPaymentItemTypeFilter;
